import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { utcDateTime } from '@epicuro-next/utilities';
import { FilterValue, OrderFilter } from 'graphql-api/baskets-api-interfaces';

import {
  DEFAULT_ORDER_BOOK_FILTERS_VALUES,
  EMPTY_CATEGORY_DISPLAY_VALUE,
  ORDER_STATUS_VALUES,
} from '../../constants';
import { isDateFilter } from '../is-date-filter/is-date-filter';
import { isIncomingFilterId } from '../is-incoming-filter/is-incoming-filter';

export function mapFilterValuesToUi(filter: OrderFilter): OrderFilter {
  return {
    ...filter,
    values: filter.values?.map((filterValue) => ({
      ...filterValue,
      value: mapValueToUI(filter.fieldId, filterValue.value),
      displayName: mapDisplayValueToUI(filter.fieldId, filterValue),
      // disable while BS years count are wrong as it refers to orders count
      count:
        filter.fieldId === FiltersFieldIds.DeliveryYear
          ? null
          : filterValue.count,
    })),
  };
}

export function mapValueToUI(fieldId: string, value: string) {
  if (fieldId === FiltersFieldIds.DeliveryYear) {
    return utcDateTime(value).year.toString();
  }

  if (isDateFilter(fieldId)) {
    return utcDateTime(value).toISODate();
  }

  if (isIncomingFilterId(fieldId)) {
    return (
      ORDER_STATUS_VALUES.find((v) =>
        [v.value, v.alternativeValue].includes(value),
      )?.value ?? value
    );
  }

  return value;
}

export function mapDisplayValueToUI(
  fieldId: string,
  { value, displayName }: FilterValue,
) {
  if (fieldId === FiltersFieldIds.DeliveryYear) {
    return utcDateTime(value).year.toString();
  }

  if (
    [
      FiltersFieldIds.SubBrand,
      FiltersFieldIds.Category,
      FiltersFieldIds.Noos,
      FiltersFieldIds.Division,
      FiltersFieldIds.MaterialGroup,
    ].includes(fieldId as FiltersFieldIds) &&
    value === ''
  ) {
    return EMPTY_CATEGORY_DISPLAY_VALUE;
  }

  return (
    (DEFAULT_ORDER_BOOK_FILTERS_VALUES[fieldId as FiltersFieldIds] ?? []).find(
      (v) => v.value === value,
    )?.displayName ?? displayName
  );
}
